import React, { PropsWithChildren } from "react";
import clsx from "clsx";

import useStyles from "./styles";

interface IProps {
  className?: string;
}

const ActionCellsWrapper = (props: PropsWithChildren<IProps>) => {
  const { className, children } = props;

  const classes = useStyles();

  return (
    <div className={classes.rowMenu}>
      <div className={clsx(classes.menuButtons, className)}>{children}</div>
    </div>
  );
};

export default React.memo(ActionCellsWrapper);
